import requester from '@/lib/axios';
import { TrueOrFalseDTO, TrueOrFalseQuestion } from '@/models/Question';

const baseUrl = 'true-or-false-activity';

export const getTrueOrFalseQuestion = async (id: number) => {
  const { data } = await requester().get<TrueOrFalseQuestion>(
    `${baseUrl}/${id}/`,
  );

  return data;
};

export const updateTrueOrFalseQuestion = async (
  id: number,
  changes: TrueOrFalseDTO,
) => {
  const { data } = await requester().patch<TrueOrFalseQuestion>(
    `${baseUrl}/${id}/`,
    changes,
  );

  return data;
};

export const deleteTrueOrFalseQuestion = async (id: number) => {
  await requester().delete<TrueOrFalseQuestion>(`${baseUrl}/${id}/`);
};

export const createTrueOrFalseQuestion = async (body: TrueOrFalseDTO) => {
  const { data } = await requester().post<TrueOrFalseQuestion>(
    `${baseUrl}/`,
    body,
  );

  return data;
};
